import { IPolicy, Policy } from "./policy";

export interface IUserGroupPolicy extends IPolicy {
    readonly userGroupId: number;
}

export class UserGroupPolicy extends Policy implements IUserGroupPolicy {
    userGroupId: number;

    constructor(init?: Partial<UserGroupPolicy>) {
        super();
        Object.assign(this, init);
    }

    getRelatedId(): number {
        return this.userGroupId;
    }

    static isUserGroupPolicy(obj: object): obj is IUserGroupPolicy {
        return (
            obj.hasOwnProperty("userGroupId") &&
            typeof (obj as IUserGroupPolicy | Record<string, unknown>).userGroupId === "number"
        );
    }
}
